import { createFileRoute } from '@tanstack/react-router';
import { authBaseUrl } from '~/features/auth/context/Session';
import { getBaseUrl } from '~/utils/getBaseUrl';

export const Route = createFileRoute('/_auth')({
  loader: async ({ context }) => {
    const session = context.session;

    if (!session) {
      window.location.href = `${getBaseUrl(authBaseUrl)}/login?return_to=${window.location.href}`;
    }
  },
});
